import React from 'react';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';
import { Button, Header, Icon, List, Modal } from 'semantic-ui-react';
import {
  DeleteConfirmation,
  Analytics,
  GlobalNotifications,
  Intent,
  MobileModal
} from '../../../Modules';
import documentStyles from '../../Document.scss';
import styleVariables from '../../../variables';
import Actions from '../../Sections/Actions/Actions';
import Search from '../../../App/SearchContainer';

export default class ContractTemplateActions extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    node: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    windowDimensions: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      alreadySignedModalOpen: false,
      deleteModalOpen: false,
      useTemplateModalOpen: false
    };
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
    this.openDeleteModal = this.openDeleteModal.bind(this);
    this.closeUseTemplateModal = this.closeUseTemplateModal.bind(this);
    this.openUseTemplateModal = this.openUseTemplateModal.bind(this);
    this.deleteTemplate = this.deleteTemplate.bind(this);
    this.selectItem = this.selectItem.bind(this);
  }

  deleteTemplate() {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to delete template',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully deleted template',
        intent: Intent.SUCCESS
      });
      this.props.router.push('/templates');
      Analytics.trackEvent('deleted-contract-template');
    };

    const mutation = graphql`
      mutation ActionsComponent_deleteCTemplateMutation(
        $input: DeleteCTemplateInput!
      ) {
        deleteCTemplate(input: $input) {
          deletedCTemplateId
        }
      }
    `;

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: { input: { id: this.props.node.id } },
      onCompleted,
      onError
    });
  }

  openDeleteModal() {
    this.setState({ deleteModalOpen: true });
  }

  openUseTemplateModal() {
    this.setState({ useTemplateModalOpen: true });
  }

  closeDeleteModal() {
    this.selectItem();
    this.setState({ deleteModalOpen: false });
  }

  closeUseTemplateModal() {
    this.selectItem();
    this.setState({ useTemplateModalOpen: false });
  }

  selectItem(callback) {
    if (this.props.onClose) this.props.onClose();
    if (typeof callback === 'function') callback();
  }

  render() {
    const ModalContent = (
      <div>
        <h4>Please select an event to use this template</h4>
        <Search
          viewer={this.props.viewer}
          onBlur={this.hideSearch}
          onFocus={this.showSearch}
          handleResultSelect={(e, data) =>
            this.props.router.push(
              `/events/${data.result
                .eventId}/workspaces/?action=new&type=contract&id=${this.props.node
                .id}`
            )}
          fluid
        />
      </div>
    );
    return (
      <div>
        {this.props.windowDimensions.width >=
          styleVariables.tabletBreakpoint &&
          <Modal open={this.state.useTemplateModalOpen} size='small' onClose={this.closeUseTemplateModal}>
            <Header content='Use Template' />
            <Modal.Content>
              {ModalContent}
            </Modal.Content>
            <Modal.Actions style={{ textAlign: 'left' }}>
              <Button basic content='Cancel' onClick={this.closeUseTemplateModal} />
            </Modal.Actions>
          </Modal>
        }
        {this.props.windowDimensions.width < styleVariables.tabletBreakpoint &&
          <MobileModal open={this.state.useTemplateModalOpen}>
            <MobileModal.Header>
              <div className='menu'>
                <a
                  className='item'
                  onClick={this.closeUseTemplateModal}
                >
                  <Icon name='chevron left' />
                </a>
              </div>
            </MobileModal.Header>
            <MobileModal.Content>
              {ModalContent}
            </MobileModal.Content>
          </MobileModal>
        }
        <DeleteConfirmation
          delete={this.deleteTemplate}
          id={this.props.node.id}
          open={this.state.deleteModalOpen}
          onClose={this.closeDeleteModal}
        />
        <Actions
          windowDimensions={this.props.windowDimensions}
          onClose={this.props.onClose}
        >
          <List>
            {this.props.params.action === 'edit' &&
              <List.Item
                onClick={() => this.props.router.replace(`/templates/c/${this.props.node.id}`)}
                className={documentStyles.actionMenuItem}
              >
                <Icon name='eye' /> &nbsp; Preview
              </List.Item>}
            {this.props.params.action !== 'edit' &&
              <List.Item
                onClick={() => this.props.router.replace(`/templates/c/${this.props.node.id}/edit`)}
                className={documentStyles.actionMenuItem}
              >
                <Icon name='pencil' /> &nbsp; Edit
              </List.Item>}
            <List.Item
              onClick={this.openUseTemplateModal}
              className={documentStyles.actionMenuItem}
            >
              <Icon name='copy outline' /> &nbsp; Use Template
            </List.Item>
            <List.Item
              onClick={this.openDeleteModal}
              className={documentStyles.actionMenuItem}
            >
              <Icon name='trash alternate' /> &nbsp; Delete Template
            </List.Item>
          </List>
        </Actions>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/Contract/Actions.js